import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.html',
  styleUrls: ['./welcome.scss'],
})
export class WelcomeComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
